module.exports = __webpack_public_path__ + "img/join-clients.eff16391.png";